<dialog-popup
  #dialog
  [title]="'Reset Start Page'"
  [displayWarningIcon]="true"
  [buttonsTemplate]="customButtons"
>
  <p>
    This action cannot be undone. <br>
    Do you really want to reset your Start Page?
  </p>

</dialog-popup>


<ng-template #customButtons>
  <app-button
    (click)="doReset()"
    buttonLabel="Yes, reset"
    [buttonType]="ButtonTypeEnum.PRIMARY"
  />

  <app-button
    (click)="dialog.closeDialog()"
    buttonLabel="Cancel"
    [buttonType]="ButtonTypeEnum.SECONDARY"
  />
</ng-template>
